import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addEmployees,
  updateEmployees,
  getEmployee,
  getInActiveEmployees,
} from "../../actions/userActions/employeeAction";

import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import { getCities } from "../../actions/userActions/cityAction";
import { getDesignations } from "../../actions/userActions/designationAction";
import { getOfficeLocations } from "../../actions/userActions/officelocationAction";
import { getDepartments } from "../../actions/userActions/departmentAction";
import { getTeams } from "../../actions/userActions/teamAction";
import { getEmploymentStatuses } from "../../actions/userActions/employmentStatusAction";
import { getRoles } from "../../actions/userActions/roleAction";
import {
  getEmployees,
  getGenders,
} from "../../actions/userActions/employeeAction";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import moment from 'moment';
import { CircularProgress } from "@mui/material";
import HrComponent from "../reuse_components/HrComponent";
import { SIZE_OF_PAGE } from "../../actions/types";
import { getvisitProfile } from "../../actions/userActions/VisitProfileAction";
import TextField from "../designSystem/TextField";
import SingleSelect from "../designSystem/SingleSelect";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import BodySmallRegular from "../designSystem/BodySmallRegular";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import { Check, CircleAlert, Info } from "lucide-react";
import { validateFields } from "../../utils/Validations";
import MultiSelect from "../designSystem/MultiSelect";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  DEFAULT_SEARCH,
  DEFAULT_STATUS
} from '../../Constatns';
import { PERMISSIONS } from "../../Permissions";
import BackNavHeader from "../subComponents/BreadCrumbs/BackNavHeader ";
import { getEmployeeLookup } from "../../actions/userActions/employeeLookupAction";

import AddNewDrawer from "../addNew/AddNewDrawer";
import AddNewForm from "../addNew/AddNewForm";
import cityicon from "../../assets/images/cityIcon (2).svg";
import designationIcon from "../../assets/images/Icon=Designations.svg";
import departmentIcon from "../../assets/images/Icon=Departments.svg";
import roleicon from "../../assets/images/roleicon.svg";
import empstatusicon from "../../assets/images/empstatusicon.svg";
import teamIcon from "../../assets/images/Icon=Team.svg";
import officeLocationIcon from "../../assets/images/Icon=Office Locations.svg";
import { t } from "../../locales/translate";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay"

function AddEmployees() {
  const [retryKey, setRetryKey] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [tryagain, setTryagain] = useState(false);
  const [name, setName] = useState("");
  const [goBack, setGoBack] = useState(false);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const user = JSON.parse(localStorage.getItem("user"));
  const userTeamId = user?.result[0]?.user?.teamId; 
  const EMPLOYEE_STATE_KEY = 'employeeState';
  const EMPLOYEE_ADD_STATE_KEY = 'employeeAddState';
  const EMPLOYEE_PATH = '/admin/employees';
  const currentDate = new Date();// Add these state variables at the top of your component
  const eighteenYearsAgo = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );
  const twentyFourYearsAgo = new Date(
    currentDate.getFullYear() - 24,
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const [page, setPage] = useState(1);

const employeeLookups = useSelector((state) => state.employeeLookupReducer.lookups);

const cities = employeeLookups?.cities || [];
const designations = employeeLookups?.designations || [];
const departments = employeeLookups?.departments || [];
const roles = employeeLookups?.roles || [];
const genders = employeeLookups?.genders || [];
const teams = employeeLookups?.teams || [];
const employmentStatuses = employeeLookups?.employmentStatuses || [];
const officeLocations = employeeLookups?.officeLocations[0]?.officeLocations;
  const cityBody = {
    filter: {
      textSearch: "",
      countryId: "1"
    },
    pageNumber: -1,
    pageSize: 0,
  };
  const designationBody = {
    filter: {
      textSearch: ""
    },
    pageNumber: -1,
    pageSize: 0,
  };
  const visitLocationbody = {
    filter: {
      textSearch: ""
    },
    pageNumber: -1,
    pageSize: 0
  }
  const locationBody = {
    filter: {
      textSearch: "",
      cityName: "",
    },
    pageNumber: -1,
    pageSize: 0,
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [birthDate, setBirthDate] = useState(twentyFourYearsAgo);
  const initialValues = {
    firstName: "",
    lastName: "",
    gender: "",
    dateOfJoining: "",
    dateOfBirth: twentyFourYearsAgo,
    nic: "",
    passport: "",
    address: "",
    city: "",
    personalContact1: "",
    personalContact2: "",
    personalEmail: "",
    designation: "",
    jobLocation: "",
    officialEmail: "",
    officialContact1: "",
    officialContact2: "",
    department: "",
    reportsTo: null,
    team: "",
    employmentStatus: "",
    password: "",
    employeeRoles: [],
    status: false,
    empId: "",
    visitProfileIds: [],
    replacementOf: null
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
   const [drawerOpen, setDrawerOpen] = useState(false);
const [drawerItem , setDrawerItem] = useState(null);
  const [inactiveLabels, setInactiveLabels] = useState({});
  const [passwordType, setPasswordType] = useState("password");
  const pageNumber = -1;

  const DRAWER_ICONS = {
  city: cityicon,
  designation: designationIcon,
  team: teamIcon,
  employmentStatus: empstatusicon,
  role: roleicon,
  department: departmentIcon,
  officeLocation: officeLocationIcon
    };

  const darwerIcon = DRAWER_ICONS[drawerItem] ? <img src={DRAWER_ICONS[drawerItem]} alt={drawerItem} /> : null;


  useEffect(() => {
    if (location.id) {
      dispatch(getEmployee(location.id));
    }

    const fetchData = async () => {
      try {
  await Promise.all([
  dispatch(getEmployeeLookup()), 
  dispatch(getEmployees(pageNumber)), 
  dispatch(getvisitProfile(pageNumber, SIZE_OF_PAGE, query)) 
]).then((response) => {

        }).catch((error) => {
          throw error;
        });
        setLoadingData(false);
      } catch (error) {
        setTryagain(true);
        setLoadingData(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, location.id, retryKey]);
  useEffect(() => {
    dispatch(getInActiveEmployees(pageNumber, SIZE_OF_PAGE, query));
  }, [dispatch]);
  useEffect(() => {
    const saveState = () => {
      if (location.state?.fromEmployee || location.employee) {
        sessionStorage.setItem(EMPLOYEE_STATE_KEY, JSON.stringify({
          page: location.state?.page || DEFAULT_PAGE,
          search: location.state?.search || DEFAULT_SEARCH,
          status: location.state?.status || DEFAULT_STATUS,
          pageSize: location.state?.pageSize || DEFAULT_PAGE_SIZE,
          team: location.state?.team || userTeamId,
          city: location.state?.city || '',
          designation: location.state?.designation || ''
        }));
      }
    };
    window.addEventListener('beforeunload', saveState);
    if (!location.state?.fromEmployee && !location.employee && sessionStorage.getItem(EMPLOYEE_STATE_KEY)) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(EMPLOYEE_STATE_KEY));
        history.replace({
          ...location,
          state: {
            fromEmployee: true,
            page: saved.page,
            search: saved.search,
            status: saved.status,
            pageSize: saved.pageSize,
            team: saved.team,
            city: saved.city,
            designation: saved.designation
          }
        });
      } catch (e) {
        console.error("Error restoring state", e);
      }
    }
    return () => window.removeEventListener('beforeunload', saveState);
  }, [location, history]);
  
  useEffect(() => {
    if (location.state && location.state.fromEmployee) {
      sessionStorage.setItem(EMPLOYEE_ADD_STATE_KEY, JSON.stringify({
        page: location.state.page || DEFAULT_PAGE,
        search: location.state.search || DEFAULT_SEARCH,
        status: location.state.status || DEFAULT_STATUS,
        pageSize: location.state?.pageSize || DEFAULT_PAGE_SIZE,
        team: location.state?.team || userTeamId,
        city: location.state?.city || '',
        designation: location.state?.designation || ''
      }));
    }
  }, [location.state]);
  const navigateBack = () => {
    let page = DEFAULT_PAGE;
    let search = DEFAULT_SEARCH;
    let status = DEFAULT_STATUS;
    let pageSize = DEFAULT_PAGE_SIZE;
    let team = userTeamId;
    let city = '';
    let designation = '';
    
    if (location.state && location.state.fromEmployee) {
      page = parseInt(location.state.page) || DEFAULT_PAGE;
      search = location.state.search || DEFAULT_SEARCH;
      status = location.state.status || DEFAULT_STATUS;
      pageSize = parseInt(location.state.pageSize) || DEFAULT_PAGE_SIZE;
      team = location.state.team || userTeamId;
      city = location.state.city || '';
      designation = location.state.designation || '';
    } else {
      try {
        const savedState = sessionStorage.getItem(EMPLOYEE_ADD_STATE_KEY);
        if (savedState) {
          const parsedState = JSON.parse(savedState);
          page = parseInt(parsedState.page) || DEFAULT_PAGE;
          search = parsedState.search || DEFAULT_SEARCH;
          status = parsedState.status || DEFAULT_STATUS;
          pageSize = parseInt(parsedState.pageSize) || DEFAULT_PAGE_SIZE;
          team = parsedState.team || userTeamId ;
          city = parsedState.city || '';
          designation = parsedState.designation || '';
        }
      } catch (e) {
        console.error("Error retrieving state", e);
      }
    }
    const getStatusNameById = (statusId) => {
      const statusMap = {
        1: 'All',
        2: 'Active',
        3: 'Inactive'
      };
      return statusMap[statusId] || 'Active';
    };
    const getTeamNameById = (teamId) => {
      if (!teamsData || !teamId) return '';
      const teamItem = teamsData.find(team => team.id == teamId);
      return teamItem ? teamItem.name : '';
    };
    
    const getCityNameById = (cityId) => {
      if (!citiesData || !cityId) return '';
      const cityItem = citiesData.find(city => city.id == cityId);
      return cityItem ? cityItem.name : '';
    };
    
    const getDesignationNameById = (designationId) => {
      if (!designationData || !designationId) return '';
      const designationItem = designationData.find(designation => designation.id == designationId);
      return designationItem ? designationItem.name : '';
    };
    
    const searchParams = new URLSearchParams();
    searchParams.set('page', page);
    searchParams.set('pageSize', pageSize);
    
    if (search) searchParams.set('search', search);
    
    let statusForUrl;
    if (typeof status === 'number') {
      statusForUrl = getStatusNameById(status);
    } else {
      statusForUrl = status;
    }
    searchParams.set('status', statusForUrl);
    if (team) {
      const teamName = getTeamNameById(team);
      if (teamName) searchParams.set('team', teamName);
    }
    
    if (city) {
      const cityName = getCityNameById(city);
      if (cityName) searchParams.set('city', cityName);
    }
    
    if (designation) {
      const designationName = getDesignationNameById(designation);
      if (designationName) searchParams.set('designation', designationName);
    }
    
    history.push({
      pathname: EMPLOYEE_PATH,
      search: searchParams.toString() ? `?${searchParams.toString()}` : '',
      state: {
        returnToEmployee: true,
        page,
        search,
        status,
        pageSize,
        team,
        city,
        designation
      }
    });
  };
  const employee = useSelector((state) => state.employees_reducer.employee);
  const visitProfile = useSelector((state) => state.visitProfile_reducer.visitProfile);
  const initialSelectedValues = {
    empId:
      employee && employee !== "isLoading" && location.id && employee.empId
        ? { label: "loading...", value: "" }
        : "",
    firstName:
      employee && employee !== "isLoading" && location.id && employee.firstName
        ? { label: "loading...", value: "" }
        : "",
    lastName:
      employee && employee !== "isLoading" && location.id && employee.lastName
        ? { label: "loading...", value: "" }
        : "",
    cnic:
      employee && employee !== "isLoading" && location.id && employee.cnic
        ? { label: "loading...", value: "" }
        : "",
    gender:
      employee && employee !== "isLoading" && location.id && employee.gender
        ? { label: "loading...", value: "" }
        : "",
    city:
      employee && employee !== "isLoading" && location.id && employee.city
        ? { label: "loading...", value: "" }
        : "",
    designation:
      employee && employee !== "isLoading" && location.id && employee.designation
        ? { label: "loading...", value: "" }
        : "",
    visitProfileIds:
      employee && employee !== "isLoading" && location.id && employee.visitProfiles
        ? []
        : [],
    replacementOf:
      employee && employee !== "isLoading" && location.id && employee.replacementOf
        ? { label: "loading...", value: "" }
        : "",
    jobLocation:
      employee &&
        employee !== "isLoading" &&
        location.id &&
        employee.jobLocation
        ? { label: "loading...", value: "" }
        : "",
    department:
      employee && employee !== "isLoading" && location.id && employee.department
        ? { label: "loading...", value: "" }
        : "",
    reportsTo:
      employee && employee !== "isLoading" && location.id && employee.reportsTo
        ? { label: "loading...", value: "" }
        : "",
    team:
      employee && employee !== "isLoading" && location.id && employee.team
        ? { label: "loading...", value: "" }
        : "",
    employmentStatus:
      employee &&
        employee !== "isLoading" &&
        location.id &&
        employee.employmentStatus
        ? { label: "loading...", value: "" }
        : "",
    employeeRoles:
      employee &&
        employee !== "isLoading" &&
        location.id &&
        employee.employeeRoles
        ? { label: "loading...", value: "" }
        : "",
  };
  const [selected, setSelected] = useState(initialSelectedValues);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFields(formValues, "employee");
    setFormErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      const updatedFormValues = {
        ...formValues,
        personalEmail: formValues.personalEmail.trim().toLowerCase(),
        officialEmail: formValues.officialEmail.trim().toLowerCase(),
        firstName: formValues.firstName.trim(),
        lastName: formValues.lastName.trim(),
        empId: formValues?.empId?.trim(),
        address: formValues.address.trim(),
        personalContact1: formValues?.personalContact1.trim(),
        personalContact2: formValues?.personalContact2?.trim(),
        passport: formValues?.passport.trim(),
        visitProfileIds: formValues.visitProfileIds || [],
      };
      if (location.id) {
        dispatch(updateEmployees(updatedFormValues))
          .then(() => {
            navigateBack();
          });
      } else {
        dispatch(addEmployees(updatedFormValues))
          .then(() => {
            navigateBack();
          });
      }
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target ? e.target : e;

    if (name === "personalEmail") {
      setFormValues({ ...formValues, personalEmail: value, officialEmail: value });
    } else if (name === "personalContact1") {
      setFormValues({ ...formValues, personalContact1: value, officialContact1: value });
    } else if (name === "status") {
      setFormValues({ ...formValues, [name]: value, status: !formValues.status });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };


   const handleAddNew = (itemName) => {
  setDrawerItem(itemName);
  setDrawerOpen(true);
};

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DDT00:00:00"); 
    setSelected(prevValues => ({
      ...prevValues,
      dateOfJoining: formattedDate,
    }));
    setFormValues(prevValues => ({
      ...prevValues,
      dateOfJoining: formattedDate,
    }));
  };
  const findInactiveEntry = (id, data) => {
    if (!Array.isArray(data)) {
      return null;
    }
    const entry = data.find(item => item.id === id);
    return entry && !entry.active ? entry : null;
  };
  
  const citiesData = cities && cities?.result?.[0]?.cities?.length && cities?.result?.[0]?.cities;
  const designationData = designations  && designations?.result?.[0]?.designations;
  
  const departmentsData = departments.result;
 

  const teamsData = teams && teams.result;


  

  const employmentStatusData = employmentStatuses.result;
  
  const rolesResultData = roles && roles.result;
  const employees = useSelector((state) => state.employees_reducer.employees);
  const employeeData = useSelector((state) => state.employees_reducer.employee);
  const InActiveEmployees = useSelector((state) => state.employees_reducer.InActivEemployees);
 
  const addEmployee = useSelector(
    (state) => state.employees_reducer.addEmployee
  );
  const updateEmployee = useSelector(
    (state) => state.employees_reducer.updateEmployee
  );
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const OPTIONS = {
    CITIES: "cities",
    GENDER: "gender",
    REPLACEMENT_OF: "replacementOf",
    DEPARTMENT: "department",
    DESIGNATION: "designation",
    EMPLOYEE_ROLES: "employeeRoles",
    TEAM: "team",
    REPORTS_TO: "reportsTo",
    VISIT_PROFILES: "visitProfiles",
    JOB_LOCATION: "jobLocation",
    EMPLOYMENT_STATUS: "employmentStatus",
  };

  const getOptions = (type) => {
    switch (type) {
      case OPTIONS.CITIES:
        return cities?.result?.[0]?.cities?.length
          ? cities.result[0].cities
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((city) => ({
              value: city.id,
              label: city.name,
            }))
          : [];

      case OPTIONS.GENDER:
        return genders?.length
          ? genders
            .filter((gender) => gender.active === true)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((gender) => ({
              value: gender.id,
              label: gender.name,
            }))
          : [];

      case OPTIONS.REPLACEMENT_OF:
        let replacementOptions = [];
        replacementOptions.push({ value: "clear", label: "None" });
        replacementOptions.push({ value: "divider", label: "──────────────", disabled: true });
        if (InActiveEmployees?.result?.length) {
          replacementOptions = replacementOptions.concat(
            InActiveEmployees.result.map((emp) => ({
              value: emp.id,
              label: `${emp.firstName} ${emp.lastName}`,
              subtext:emp.designationName
            }))
          );
        } else {
          replacementOptions.push({ value: "", label: "No available replacements" });
        }

        return replacementOptions;

      case OPTIONS.DEPARTMENT:
        return departmentsData?.length
          ? departmentsData
            .filter((dept) => dept.active === true)
            .map((dept) => ({
              value: dept.id,
              label: dept.name,
            }))
          : [];

      case OPTIONS.DESIGNATION:
        return designations?.result?.[0]?.designations?.length
          ? designations.result[0].designations
            .filter((desig) => desig.active === true)
            .map((desig) => ({
              value: desig.id,
              label: desig.name,
            }))
          : [];

      case OPTIONS.EMPLOYEE_ROLES:
        return rolesResultData?.length
          ? rolesResultData
            .filter((role) => role.active === true)
            .map((role) => ({
              value: role.id,
              label: role.name,
            }))
          : [];

      case OPTIONS.TEAM:
        return teamsData?.length
          ? teamsData
            .filter((team) => team.active === true)
            .map((team) => ({
              value: team.id,
              label: team.name,
            }))
          : [];

      case OPTIONS.REPORTS_TO:
        return employees?.result?.length
          ? employees.result
            .filter((employee) => employee.status === true)
            .map((emp) => ({
              value: emp.id,
              label: `${emp.firstName} ${emp.lastName}`,
              subtext:emp.designationName
            }))
          : [];

      case OPTIONS.VISIT_PROFILES:
        return visitProfile?.result?.length
          ? visitProfile.result.map((profile) => ({
            value: profile.visitProfileId,
            label: `${profile?.systemGeneratedName || ""} - ${profile.profileName}`,
          }))
          : [];

      case OPTIONS.JOB_LOCATION:
        return officeLocations?.result?.[0]?.officeLocations?.length
          ? officeLocations.result[0].officeLocations.map((location) => ({
            value: location.id,
            label: location.address,
          }))
          : [];

      case OPTIONS.EMPLOYMENT_STATUS:
        return employmentStatuses?.result?.length
          ? employmentStatuses.result
            .filter((status) => status.active === true)
            .map((status) => ({
              value: status.id,
              label: status.name,
            }))
          : [];

      default:
        return [];
    }
  };


  useEffect(() => {
    if (!loadingData && location.id) {
      employee &&
        employee !== "isLoading" &&
        setSelected({
          ...selected,
          ["gender"]: getOptions(genders, "gender")[
            getOptions(genders, "gender")
              .map((e) => e.value)
              .indexOf(employee.gender)
          ],
          ["city"]: getOptions(cities && cities !== "isLoading" && cities.result?.[0]?.cities.length !== 0 && cities.result?.[0]?.cities, "city")[
            getOptions(cities && cities !== "isLoading" && cities.result?.[0]?.cities.length !== 0 && cities.result?.[0]?.cities, "city")
              .map((e) => e.value)
              .indexOf(employee.city)
          ],
          ["designation"]: getOptions(designations && designations !== "isLoading" && designations.length !== 0 && designations?.result?.[0]?.designations, "designation")[
            getOptions(designations && designations !== "isLoading" && designations.length !== 0 && designations?.result?.[0]?.designations, "designation")
              .map((e) => e.value)
              .indexOf(employee.designation)
          ],
          ["jobLocation"]: getOptions(
            officeLocations && officeLocations !== "isLoading" && officeLocations.length !== 0 && officeLocations.result?.[0]?.officeLocations,
            "jobLocation"
          )[
            getOptions(officeLocations.officeLocations, "jobLocation")
              .map((e) => e.value)
              .indexOf(employee.jobLocation)
          ],
          ["department"]: getOptions(departments && departments !== "isLoading" && departments.length !== 0 && departments.result, "department")[
            getOptions(departments && departments !== "isLoading" && departments.length !== 0 && departments.result, "department")
              .map((e) => e.value)
              .indexOf(employee.department)
          ],
          ["team"]: getOptions(teamsData, "team")[
            getOptions(teamsData, "team")
              .map((e) => e.value)
              .indexOf(employee.team)
          ],
          ["reportsTo"]: getOptions(employees.result, "reportsTo")[
            getOptions(employees.result, "reportsTo")
              .map((e) => e.value)
              .indexOf(employee.reportsTo)
          ],
          ["employmentStatus"]: getOptions(employmentStatuses.result, "employmentStatus")[
            getOptions(employmentStatuses.result, "employmentStatus")
              .map((e) => e.value)
              .indexOf(employee.employmentStatus)
          ],
          ["employeeRoles"]: getOptions(roles && Array.isArray(rolesResultData) && rolesResultData, "employeeRoles")[
            getOptions(roles, "employeeRoles")
              .map((e) => e.value)
              .indexOf(
                employee.employeeRoles[0] && employee.employeeRoles[0].roleId
              )
          ],
          ["visitProfileIds"]: employee.visitProfiles && employee.visitProfiles.length > 0
            ? employee.visitProfiles.map(profile => ({
              value: profile.visitProfileId,
              label: profile.profileName
            }))
            : []
        });
      {
        employee &&
          employee !== "isLoading" &&
          setFormValues({
            ...formValues,
            ["firstName"]: employee.firstName,
            ["lastName"]: employee.lastName,
            ["gender"]: employee.gender,
            ["dateOfJoining"]: employee.dateOfJoining,
            ["dateOfBirth"]: employee.dateOfBirth,
            ["nic"]: employee.nic,
            ["passport"]: employee.passport,
            ["address"]: employee.address,
            ["city"]: employee.city,
            ["personalContact1"]: employee.personalContact1,
            ["personalContact2"]: employee.personalContact2,
            ["personalEmail"]: employee.personalEmail,
            ["designation"]: employee.designation,
            ["visitProfileIds"]: employee.visitProfiles ? employee.visitProfiles.map(profile => profile.visitProfileId) : [],
            ["replacementOf"]: employee.replacementOf,
            ["jobLocation"]: employee.jobLocation,
            ["officialEmail"]: employee.officialEmail,
            ["officialContact1"]: employee.officialContact1,
            ["officialContact2"]: employee.officialContact2,
            ["department"]: employee.department,
            ["reportsTo"]: employee.reportsTo,
            ["team"]: employee.team,
            ["employmentStatus"]: employee.employmentStatus,
            ["password"]: employee.password,
            ["employeeRoles"]: employee.employeeRoles,
            ["id"]: location.id,
            ["empId"]: employee.empId,
            ["status"]: employee.status,
            ["dateOfJoining"]: employee.dateOfJoining ? moment(employee.dateOfJoining).format('YYYY-MM-DD') : ""
          });
      }
      {
        employee &&
          employee !== "isLoading" &&
          setSelected(prevValues => ({
            ...prevValues,
            dateOfJoining: moment(employee.dateOfJoining).format('MM-DD-YYYY')
          }));
      }
      {
        employee &&
          employee !== "isLoading" &&
          setBirthDate(new Date(employee.dateOfBirth));
      }
    }
    if (!loadingData && location.id) {
      setName(employee.firstName + " " + employee.lastName);
      const inactiveLabels = {};
      if (departmentsData && departmentsData.length !== 0 && departmentsData != 'isLoading') {
        const inactiveDepartment = findInactiveEntry(formValues.department, departmentsData);
        if (inactiveDepartment) {
          inactiveLabels.department = (
            <p className="text-red">
              {`${inactiveDepartment.name} is inactive!`}
            </p>
          );
        }
      }
      if (teams && Array.isArray(teamsData) && teamsData !== 'isLoading' && teamsData.length !== 0 && teamsData) {
        const inactiveTeam = findInactiveEntry(formValues.team, teamsData);
        if (inactiveTeam) {
          inactiveLabels.team = (
            <p className="text-red">
              {`${inactiveTeam.name} is inactive!`}
            </p>
          );
        }
      }
      if (employmentStatusData && employmentStatusData.length !== 0 && employmentStatusData != 'isLoading') {
        const inactiveEmploymentStatus = findInactiveEntry(formValues.employmentStatus, employmentStatusData);
        if (inactiveEmploymentStatus) {
          inactiveLabels.employmentStatus = (
            <p className="text-red">
              {`${inactiveEmploymentStatus.name} is inactive!`}
            </p>
          );
        }
      }
      if (designationData && designationData.length !== 0 && designationData != 'isLoading') {
        const inactiveDesignation = findInactiveEntry(formValues.designation, designationData);
        if (inactiveDesignation) {
          inactiveLabels.designation = (
            <p className="text-red">
              {`${inactiveDesignation.name} is inactive!`}
            </p>
          );
        }
      }
      if (roles && Array.isArray(rolesResultData) && rolesResultData && rolesResultData.length !== 0 && rolesResultData != 'isLoading') {
        const selectedRoles = formValues.employeeRoles.map(role => ({
          roleId: role.roleId,
          roleName: role.roleName,
          active: true,
        }));

        const inactiveRoles = selectedRoles.filter(selectedRole => {
          const role = roles && Array.isArray(rolesResultData) && rolesResultData.find(r => r.id === selectedRole.roleId);
          if (role) {
            selectedRole.active = role.active;
            return !role.active;
          }
          return false;
        });

        if (inactiveRoles.length > 0) {
          inactiveLabels.employeeRoles = (
            <div>
              {inactiveRoles.map(role => (
                <p key={role.roleId} className="text-red">
                  {`${role.roleName} is inactive!`}
                </p>
              ))}
            </div>
          );
        }
      }

      setInactiveLabels(inactiveLabels);
    }
  }, [
    loadingData,
    location.id,
    location.empId,
    employee,
    genders,
    cities,
    designations,
    officeLocations,
    departments,
    teamsData,
    employmentStatuses,
    roles
  ]);
  useEffect(() => {
    if (employeeData && formValues.replacementOf) {
      setFormValues({
        ...formValues,
        department: employeeData.department,
        employeeRoles: employeeData.employeeRoles,
        visitProfileIds: employeeData.visitProfiles ? employeeData.visitProfiles.map(profile => profile.visitProfileId) : [],
        designation: employeeData.designation,
        reportsTo: employeeData.reportsTo,
        team: employeeData.team
      });
    }
  }, [employeeData]);

  const handleGoBack = () => {
    history.goBack();
  };
  const onRetry = () => {
    setRetryKey(!retryKey);
    setTryagain(false);
    setLoading(true);
  }
 
  if (tryagain) {
    return (
      <div className="error-container">
        <h2>Something went wrong</h2>
        <p>Looks like we're experiencing an issue, please check your internet connection and try again.</p>
        <button className="retry-button" onClick={onRetry}>
          &#x21bb; Try Again
        </button>
      </div>
    );
  }


  const handletextChange = (event) => {
    const { name, value } = event.target;
    if (name === "personalEmail") {
      setFormValues({ ...formValues, personalEmail: value, officialEmail: value });
    }
    else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };
  const handleselectChange = (event, fieldName) => {
    if (fieldName === "replacementOf" && event.value === "clear") {
      setFormValues({
        ...formValues,
        replacementOf: null,
        department: "",
        employeeRoles: [],
        visitProfileIds: [],
        designation: "",
        reportsTo: "",
        team: "",
      });
      return; 
    }
  
    setFormValues({
      ...formValues,
      [fieldName]: event.value,
    }); 
    if (fieldName === "replacementOf" && event.value) {
      dispatch(getEmployee(event.value));
    }
  };  
  const handleSelectChange = (selectedOption, fieldName) => {
    if (!selectedOption || selectedOption.value === "clear") {
      setFormValues({
        ...formValues,
        [fieldName]: null
      });
      setSelected({ ...selected, [fieldName]: null });
      return;
    }
    const { value, label } = selectedOption;
    const inactive = { ...inactiveLabels };
    if (fieldName === "employeeRoles" && roles && Array.isArray(rolesResultData) && rolesResultData.length !== 0) {
      const inactiveRole = findInactiveEntry(value, roles);
      inactive.employeeRoles = inactiveRole ? (
        <p className="text-red">{`${inactiveRole.name} is inactive!`}</p>
      ) : null;
    } else if (fieldName === "reportsTo" && employees?.result) {
      const inactiveEmployee = findInactiveEntry(value, employees.result);
      inactive.reportsTo = inactiveEmployee ? (
        <p className="text-red">{`${inactiveEmployee.name} is inactive!`}</p>
      ) : null;
    }
    setInactiveLabels(inactive);
    setFormValues({
      ...formValues,
      [fieldName]: fieldName === "employeeRoles"
        ? employee
          ? [{ roleId: value, employeeId: location.id }]
          : [{ roleId: value }]
        : value,
    });
    setSelected({ ...selected, [fieldName]: { value, label } });
  };
  const handleCityChange = (event) => {
    setFormValues({
      ...formValues,
      city: event.value
    });
  };

  const handllereportstochng = (event) => {
    setFormValues({
      ...formValues,
      reportsTo: event.value
    });
  };

  const handleVisitProfileChange = (updatedValues) => {
    setFormValues((prevState) => ({
      ...prevState,
      visitProfileIds: updatedValues
    }));
  };
  return (
    <>
      {addEmployee && addEmployee === true && !location.id && <Redirect to="/admin/employees" />}
      {updateEmployee && updateEmployee === true && goBack && <Redirect to="/admin/employees" />}
      {!permissions.includes(PERMISSIONS.CAN_ADD_EMPLOYEE) && <Redirect to="/admin" />}
      {!permissions.includes(PERMISSIONS.CAN_UPDATE_EMPLOYEE) && <Redirect to="/admin" />}
      {!location.id && <Redirect to={"/admin/Addemployees"} />}
      <div className="add-visit-profile-container">
        <LoadingOverlay isVisible={loading}/>
        <BackNavHeader text={t("addEmployee")} onBack={handleGoBack}/>
        <div className="add-content-wrapper">
          <div className="row">
            <div className="col-12">
              <Heading6Regular text={t("personalDetails")} color="#1E293B" />
            </div>
          </div>

          <HrComponent />
          <div className="row">
            <div className="col-6">
              <TextField

                name="empId"
                label="Emp Id"
                type='text'
                value={formValues.empId}
                onChange={handletextChange}
                placeholder='Enter empid'
                error={formErrors.empId}
              />
            </div>

            <div className="col-6">
              <TextField

                name="nic"
                label={t("cnicNo")}
                type='text'
                value={formValues.nic}
                onChange={handletextChange}
                placeholder={t("cnicNo")}
                error={formErrors.nic}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <TextField

                name="firstName"
                label={`${t("firstName")} *`}
                type='text'
                value={formValues.firstName}
                onChange={handletextChange}
                placeholder={t("firstName")}
                error={formErrors.firstName}
              />
            </div>

            <div className="col-6">
              <TextField

                name="lastName"
                label={`${t("lastName")} *`}
                type='text'
                value={formValues.lastName}
                onChange={handletextChange}
                placeholder={t("lastName")}
                error={formErrors.lastName}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <SingleSelect
                label={`${t("gender")} *`}
                iconEnd
                error={formErrors.gender}
                onChange={(event) => handleselectChange(event, 'gender')}
                value={formValues.gender}
                placeholder={t("gender")}
                options={(genders &&
                  genders !== "isLoading" &&
                  genders.length !== 0) &&
                  getOptions("gender")}
              />
            </div>

            <div className="col-6">
              <TextField
                name="passport"
                label={t("passportNo")}
                type='text'

                value={formValues.passport}
                onChange={handletextChange}
                placeholder={t("passportNo")}
                error={formErrors.passport}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <TextField
                name="personalEmail"
                label={`${t("personalEmail")} *`}
                type='text'
                disabled={location.id ? true : false}
                value={formValues.personalEmail}
                onChange={handletextChange}
                placeholder={t("personalEmail")}
                error={formErrors.personalEmail}
              />

            </div>

            <div className="col-6">
              <SingleSelect
              
                label={`${t("city")} *`}

                isSearchable
                onChange={handleCityChange}
                iconEnd
                error={formErrors.city}
                value={formValues.city}
                placeholder={t("city")}
                options={
                  Array.isArray(cities) && cities.length > 0
                    ? cities.map((city) => ({
                        label: city.name,
                        value: city.id
                      }))
                    : []
                }
                configKey={"city"}
                onAddNewClick={() => handleAddNew("city")}

              />

            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <TextField

                name="personalContact1"
                label={`${t("personalContact")} 1 *`}
                type='text'
                value={formValues.personalContact1}
                onChange={handletextChange}
                placeholder={`${t("personalContact")} 1`}
                error={formErrors.personalContact1}
              />
            </div>

            <div className="col-6">
              <TextField

                name="personalContact2"
                label={`${t("personalContact")} 2`}
                type='text'
                value={formValues.personalContact2}
                onChange={handletextChange}
                placeholder={`${t("personalContact")} 2`}
                error={formErrors.personalContact2}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <TextField
                name="address"
                label={`${t("address")} *`}
                type='text'
                value={formValues.address}
                onChange={handletextChange}
                placeholder={t("address")}
                error={formErrors.address}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex">
              <Heading6Regular text={t("officialDetails")} color="#1E293B" />
            </div>
          </div>

          <HrComponent />

          <div className="row">
            <div className="col-6">
              <SingleSelect
                label="In Replacement Of"
                isSearchable
                iconEnd

                disabled={location.id}
                onChange={(event) => handleselectChange(event, 'replacementOf')}
                value={formValues.replacementOf}
                placeholder="Select an employee"
                options={getOptions("replacementOf")}
              />
            </div>

            <div className="col-6">
              <MultiSelect
                labelIconRight={<Info size={16} color="#64748B" />}
                tooltipFormat="Employee ID - Employee Name - Visit Profile # - Visit Profile Name"
                tooltipExample="12345-Muhammad Awais Ali-01-Derma"
                isSearchable
                onChange={handleVisitProfileChange}
                value={formValues?.visitProfileIds || []}
                label={t("visitProfile")}
                options={getOptions("visitProfiles")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
             <SingleSelect
                  label={`${t("department")} *`}
                  isSearchable
                  iconEnd
                  error={formErrors.department}
                  onChange={(event) => handleselectChange(event, 'department')}
                  value={formValues.department}
                  placeholder={t("department")}
                  options={
                    Array.isArray(departments) && departments.length > 0
                      ? departments.map((dept) => ({
                          label: dept.name,
                          value: dept.id
                        }))
                      : []
                  }
                  configKey={"department"}
                  onAddNewClick={() => handleAddNew("department")}
              />
              </div>

            <div className="col-6">
               <SingleSelect
                    label={`${t("designation")} *`}
                    isSearchable
                    iconEnd
                    error={formErrors.designation}
                    onChange={(event) => handleselectChange(event, 'designation')}
                    value={formValues.designation}
                    placeholder={t("designation")}
                    options={
                      Array.isArray(designations?.[0]?.designations)
                        ? designations[0].designations.map((item) => ({
                            label: item.name,
                            value: item.id
                          }))
                        : []
                    }
                    onAddNewClick={() => handleAddNew("designation")}
                    configKey={"designation"}
                />

            </div>
          </div>
          <div className="row">
            <div className="col-6">
                <SingleSelect
                    label={`${t("role")} *`}
                    isSearchable
                    secondaryLabel
                    iconEnd
                    error={formErrors.employeeRoles}
                    onChange={(option) => handleSelectChange(option, "employeeRoles")}
                    value={formValues?.employeeRoles?.length > 0 ? formValues.employeeRoles[0].roleId : ""}
                    placeholder={t("role")}
                    options={
                      Array.isArray(employeeLookups?.roles) && employeeLookups.roles.length > 0
                        ? employeeLookups.roles.map((role) => ({
                            label: role.name,
                            value: role.id
                          }))
                        : []
                    }
                    configKey={"role"}
                    onAddNewClick={() => handleAddNew("role")}
                  />             
            </div>

            <div className="col-6">
              <SingleSelect
                  label={`${t("team")} *`}
                  isSearchable
                  iconEnd
                  error={formErrors.team}
                  onChange={(event) => handleselectChange(event, 'team')}
                  value={formValues.team}
                  placeholder={t("team")}
                  options={
                    Array.isArray(teams) && teams.length > 0
                      ? teams.map((team) => ({
                          label: team.name,
                          value: team.id
                        }))
                      : []
                  }
                  configKey={"team"}
                  onAddNewClick={() => handleAddNew("team")}
                />
              
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <SingleSelect
                options={getOptions("reportsTo")}
                value={formValues.reportsTo}
                onChange={handllereportstochng}
                label={`${t("reportsTo")} *`}
                placeholder={t("reportsTo")}
                isSearchable
                error={formErrors.reportsTo}
              />

            </div>

            <div className="col-6">
              <div style={{ marginBottom: "6px" }}>
                <BodySmallMedium text={`${t("dateOfJoining")} *`} />
              </div>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    value={selected.dateOfJoining ? dayjs(selected.dateOfJoining) : null}
    onChange={handleDateChange}
    format="MMMM D, YYYY" // e.g., "April 15, 2025"
    sx={{
      width: "100%",
      "& .MuiOutlinedInput-root": {
        height: "40px",
        padding: "0",
        boxSizing: "border-box",
        backgroundColor: "transparent",
        border: "1px solid #E0E0E0",
        borderRadius: "60px",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
      },
      "& .MuiInputBase-input": {
        height: "32px",
        padding: "0px 8px",
        fontSize: "14px",
        color: "#637381",
      },
      "& .MuiIconButton-root": {
        padding: "20px",
      },
    }}
  />
</LocalizationProvider>

              {formErrors.dateOfJoining && (
                <div className="error-text-container">
                  <CircleAlert height={16} />
                  <span className="error-text">{formErrors.dateOfJoining}</span>
                </div>
              )}
            </div>

          </div>
          <div className="row">
            <div className="col-6">
              <SingleSelect
                  label={`${t("employmentStatus")} *`}
                  isSearchable
                  iconEnd
                  error={formErrors.employmentStatus}
                  onChange={(event) => handleselectChange(event, 'employmentStatus')}
                  value={formValues.employmentStatus}
                  placeholder={t("employmentStatus")}
                  options={
                    Array.isArray(employmentStatuses) && employmentStatuses.length > 0
                      ? employmentStatuses.map((status) => ({
                          label: status.name,
                          value: status.id
                        }))
                      : []
                  }
                  configKey={"employmentStatus"}
                  onAddNewClick={() => handleAddNew("employmentStatus")}
                />
              
            </div>

            <div className="col-6">
              
              <SingleSelect
                  label={`${t("officeLocation")} *`}
                  isSearchable
                  iconEnd
                  error={formErrors.jobLocation}
                  onChange={(event) => handleselectChange(event, 'jobLocation')}
                  value={formValues.jobLocation}
                  placeholder={t("officeLocation")}
                  options={
                    Array.isArray(employeeLookups.officeLocations?.[0]?.officeLocations)
                      ? employeeLookups.officeLocations[0].officeLocations.map(location => ({
                          label: location.address,
                          value: location.id
                        }))
                      : []
                  }
                  configKey={"officeLocation"}
                  onAddNewClick={() => handleAddNew("officeLocation")}
                />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group" style={{ display: "flex", alignItems: "flex-start" }}>
              <input
                name="status"
                style={{ cursor: "pointer", height: "16px", width: "16px" }}
                type="checkbox"
                checked={formValues.status}
                className="mt-3"
                onChange={handleChange}
              />

              <label
                style={{ paddingLeft: "10px", }}
                className="form-control-label mt-2"

              >
                {t("active")}
              </label>
            </div>
          </div>
          <hr />

          <div className="add-visit-profile-form-actions">
            <CancelButton onClick={handleGoBack} text={t("cancel")} width={document.body.dir === "rtl" ? "119px" : ""}/>
            <PrimaryButton
              onClick={handleSubmit}
              isLoading={addEmployee === "isLoading" || updateEmployee === "isLoading"}
              text={location.employee ? `${t("update")}` : `${t("save")}`}
              icon={Check}
              width={location.employee ? "95px": document.body.dir === "rtl" ? "123px" : ""}
            />

          </div>
        </div> 
      </div>
      <AddNewDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          title={drawerItem? t("addItem").replace(/{{item}}/g, t(drawerItem)): ""}
          subtext={drawerItem ? t("createNewItemRecord").replace(/{{item}}/g, t(drawerItem)) : ""}
          icon={darwerIcon}
        >
          {drawerItem  && (
           <AddNewForm
              itemName={drawerItem }
              onClose={() => setDrawerOpen(false)}
              onSave={(newData) => {
              if (drawerItem === "city") {
                dispatch(getCities(cityBody)).then(() => {
                  setFormValues((prev) => ({
                    ...prev,
                    city: { value: newData.id, label: newData.name }
                  }));
                });
              } 
              
              if (drawerItem === "designation") {
                dispatch(getDesignations(designationBody)).then(() => {
                  setFormValues((prev) => ({
                    ...prev,
                    designation: { value: newData.id, label: newData.name }
                  }));
                });
              }

              if (drawerItem === "department") {
             dispatch(getDepartments()).then(() => {
               setFormValues((prev) => ({
                 ...prev,
                 department: { value: newData.id, label: newData.name }
               }));
             });
           }

              if (drawerItem === "role") {
             dispatch(getRoles()).then(() => {
               setFormValues((prev) => ({
                 ...prev,
                 role: {value: newData.id, label: newData.name} 
               }));
             });
           }

              if (drawerItem === "employmentStatus") {
             dispatch(getEmploymentStatuses()).then(() => {
               setFormValues((prev) => ({
                 ...prev,
                 employmentStatus: { value: newData.id, label: newData.name }
               }));
             });
           }

              if (drawerItem === "team") {
             dispatch(getTeams()).then(() => {
               setFormValues((prev) => ({
                 ...prev,
                 team: { value: newData.id, label: newData.name }
               }));
             });
           }

              if (drawerItem === "officeLocation") {
             dispatch(getOfficeLocations()).then(() => {
               setFormValues((prev) => ({
                 ...prev,
                 team: { value: newData.id, label: newData.name }
               }));
             });
           }

             }}
              />
              )}
         </AddNewDrawer>
    </>
  );
}

export default AddEmployees;
